module.exports = __webpack_public_path__ + "assets/media/background.926e5261.webm";